import React from "react";
import { Link } from "react-router-dom";

export default function HowItWorks() {
  const steps = [
    { n: "01", t: "Share Your Property Details", b: "Send us property location, ownership proof, photos and your main concern — tenant, vacant plot, maintenance, rent or documentation." },
    { n: "02", t: "We Inspect & Create a Care Plan", b: "Our Chennai field team visits the property, records its condition, checks visible risks and recommends the right monitoring or management plan." },
    { n: "03", t: "You Receive Verified Updates", b: "You get inspection reports, geo-tagged photos, videos, rent updates and action recommendations via WhatsApp, email or your owner dashboard." },
  ];
  return (
    <div data-testid="page-how-it-works">
      <section className="bg-brand-navy text-white">
        <div className="container-x py-20 md:py-28">
          <div className="eyebrow !text-brand-cyan">How It Works</div>
          <h1 className="mt-3 font-display text-4xl md:text-6xl font-bold leading-tight max-w-4xl">The 3-Step Peace of Mind Process.</h1>
        </div>
      </section>
      <section className="section-pad">
        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((s) => (
            <div key={s.n} className="card-flat p-8">
              <div className="font-display text-5xl text-brand-cyan font-bold">{s.n}</div>
              <div className="mt-4 font-display text-2xl text-brand-navy font-bold">{s.t}</div>
              <p className="mt-2 text-sm text-brand-slate/80 leading-relaxed">{s.b}</p>
            </div>
          ))}
        </div>
        <div className="mt-12">
          <Link to="/contact" className="btn-cyan">Book a Free Property Consultation</Link>
        </div>
      </section>
    </div>
  );
}
